import React from 'react';
import { all, call, put, select, takeEvery } from "redux-saga/effects"
import { actionAccountLoaded, actionReceiveGroupsLoaded, getUser } from './auth';
import { db } from './firebase';

const DASHBOARD_SETUP_REQUESTED = 'DASHBOARD_SETUP_REQUESTED';

function getAccount(user) {
  const queryGetAccount = db.collection('accounts').doc(user.uid).get()

  return queryGetAccount.then(doc => {
    return doc.data();
  });
}

function getReceiveGroups(account) {
  console.debug("Get groups for account=", account);
  const queryReceiveGroups = db.collection('users').doc(account.name).collection('receiveGroups').limit(5000);

  return queryReceiveGroups.get()
    .then(snapshot => {
      const groups = [];
      snapshot.forEach(x => {
        groups.push(x.data());
      });
      return groups;
    });
}

export function actionDashboardRequestSetup() {
  return {
    type: DASHBOARD_SETUP_REQUESTED
  }
}


function* dashboardSetup() {
  const user = yield select(getUser);
  const account = yield call(getAccount, user);
  yield put(actionAccountLoaded(account));
  const receiveGroups = yield call(getReceiveGroups, account);
  yield put(actionReceiveGroupsLoaded(receiveGroups));
}

function* setupDashboardSaga() {
  yield takeEvery(DASHBOARD_SETUP_REQUESTED, dashboardSetup);
}

export function* dashboardSaga() {
  yield all([setupDashboardSaga()])
}



// WEBPACK FOOTER //
// ./src/data/dashboard.js